import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'FilterPipe'
})
export class FilterPipe implements PipeTransform {
    transform(input: object[], ...args: any[]): boolean {
        const filterWith = args[0].toLowerCase();
        try {
            const filterBy = args[1](input).toLowerCase();
            if (filterBy.indexOf(filterWith) > -1)
                return false;
            return true;
        } catch (e) {
            console.log('FilterPipe error ' + e);
        }
    }
}
